module.exports = __webpack_public_path__ + "img/icon_title_label.66342739.png";